function isEmpty(value) {
  return typeof value === 'undefined' || value === null || value === '';
}

export default isEmpty;